import {
	ALREADY_REGISTERED, AVAILABLE, COMPLETE, UNAVAILABLE, UNDER_CONSTRUCTION
} from '@/constants/signup-queries'

const signupStatus = [ AVAILABLE, UNDER_CONSTRUCTION, UNAVAILABLE, ALREADY_REGISTERED, COMPLETE ] as const
type SignupStatus = typeof signupStatus[number]
const isSignupStatus = (status: any): status is SignupStatus => signupStatus.includes(status)

export {
	isSignupStatus, type SignupStatus
}
